





















import Vue from 'vue';
import Component from 'vue-class-component';
import AppSession from '@/store/AppSession';
import ApiUtils from '@/utils/ApiUtils';
import {trackerUserLogout} from '@/plugins/raygun';

@Component({
  errorCaptured(error: Error, vm: Vue, info: any = {}) {
    (this as App).collectErrorLog('ERROR_CAPTURED', {
      reason: info,
      error: {
        name: error?.name ?? 'Uncategorized error name',
        message: error?.message ?? 'empty message',
        stack: error?.stack ?? 'empty stack'
      }
    });
  }
})
export default class App extends Vue {
  public beforeMount() {
    window.addEventListener('beforeunload', this.preventUnload);
    window.addEventListener('error', this.handleError);
    window.addEventListener('dragover', (e) => e.preventDefault());
    window.addEventListener('drop', (e) => e.preventDefault());
  }

  public beforeDestroy() {
    window.removeEventListener('beforeunload', this.preventUnload);
    trackerUserLogout();
  }

  private preventUnload($event: any) {
    const changed = Object.assign(
        {},
        this.$store.state.valueChangedMap,
        this.$store.state.notationChangedMap,
        this.$store.state.nullFlavorChangedMap);
    if (Object.keys(changed).length > 0) {
      $event.returnValue = false;     // Gecko, Trident, Chrome 34+
      return false;
    } else {
      return true;
    }
  }

  private handleError($event: any) {
    this.collectErrorLog('[onError]', {
      reason: $event
    });
  }

  public collectErrorLog(category: string, additional: any = {}) {
    const obj = {
      category,
      userId: this.$store.getters.userId,
      userKey: this.$store.getters.userKey,
      token: AppSession.getAccessToken(),
      route: {
        fullPath: this.$route.fullPath,
        path: this.$route.path,
        name: this.$route.name,
        params: this.$route.params,
        query: this.$route.query
      },
      additional: {
        ...additional,
        category
      }
    };
    ApiUtils.reportError(category, obj);
  }

}
